import { Box, Select, Option, Typography } from "@mui/joy";
import { useEffect, useState } from "react";
import { Building } from "lucide-react";

interface IBuildingStories {
    value: string | null;
    onChange: (value: string) => void;
    loading?: boolean;
}

/**
 * Number of stories selector — drives high roof charge in Xactimate.
 * 2+ stories = additional charge per SQ.
 */
export function BuildingStories(props: IBuildingStories) {
    const { value, onChange, loading } = { ...props };
    const [stories, setStories] = useState<string | null>(null);

    const handleUpdate = (event: any, newValue: string | null) => {
        if (loading) return;
        const selectedValue = newValue || "";
        setStories(selectedValue);
        onChange(selectedValue);
    };

    useEffect(() => {
        if (value) {
            setStories(value);
        }
    }, [value]);

    return (
        <Box flex={1}>
            <Typography level="body-sm" sx={{ fontWeight: "md", mb: 0.5 }}>
                Stories
            </Typography>

            <Select
                placeholder="Select stories"
                value={stories}
                onChange={handleUpdate}
                disabled={loading}
                startDecorator={<Building size={16} />}
                slotProps={{ listbox: { sx: { zIndex: 10001 } } }}
            >
                <Option value="1">1</Option>
                <Option value="2+">2+</Option>
            </Select>
        </Box>
    );
}
